// extracted by mini-css-extract-plugin
export default {"confettiContainer":"Confetti_confettiContainer__gaR9b","confettiPiece":"Confetti_confettiPiece__D6dlM","confettiFall":"Confetti_confettiFall__8Q5qJ"};